/**
 * @file
 * Miscellaneous layerone behaviors: image gallery toggle, publication
 * download button styling, sort-selection visibility and responsive tables.
 *
 * Requires global.js to be loaded first (Drupal.layerone.getScreenWidth).
 */
(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.layeroneMisc = {
    attach: function (context, settings) {

      $(once('layerone-gallery-toggle', '.layerone-gallery', context)).each(function () {
        var $gallery = $(this);
        var $toggleBtn = $gallery.find('.gallery-toggle');
        var $galleryInfo = $gallery.find('.show-all-gallery-items');
        var $buttonText = $toggleBtn.find('.button-text');
        var $buttonIcon = $toggleBtn.find('.icon');
        var originalLabel = $buttonText.text().trim();

        $toggleBtn.on('click', function (e) {
          e.preventDefault();
          var expand = $toggleBtn.attr('aria-expanded') !== 'true';

          $toggleBtn.attr('aria-expanded', expand);
          $gallery.toggleClass('gallery-expanded', expand);
          $galleryInfo.toggleClass('expanded', expand);
          $buttonText.text(expand ? 'Hide project photos' : originalLabel);

          $buttonIcon.toggleClass('icon-expanded', !expand);
          $buttonIcon.toggleClass('icon-shrink', expand);
        });
      });

      function changeDownloadButtonColour() {
        if ($('.paragraph--type--publication .btn-secondary').length > 0 || $('.publication-top-container-full .btn-secondary').length > 0) {
          $('.publication-top-container .btn-secondary, .publication-top-container-full .btn-secondary').each(function() {
            $(this)
              .removeClass('bg-white')
              .removeClass('btn-secondary')
              .addClass('bg-mid-green')
              .attr('data-background', 'bg-mid-green')
              .attr('data-background-hover', 'bg-dark-navy')
              .attr('data-text', 'text-dark-navy')
              .attr('data-text-hover', 'text-white');
            $(this).find('.button-text')
              .removeClass('text-dark-navy')
              .removeClass('me-2')
              .addClass('ms-1')
              .addClass('me-1');
            $(this).find('.icon').hide();
          });
        }
      }

      changeDownloadButtonColour();

      // Text-to-speech helper for page content. Currently unused (see
      // commented-out call below) but kept for future accessibility work.
      function setupSpeechButton(contentId, buttonId) {
        const content = document.getElementById(contentId);
        const button = document.getElementById(buttonId);
        let isSpeaking = false;
        let utterance = null;

        function speakContent() {
          if (isSpeaking) {
            window.speechSynthesis.cancel();
            isSpeaking = false;
            /* button.textContent = 'Listen'; */
            button.innerHTML = "<span class=\"icon icon-24 icon-sound filter-charcoal-hero\"></span><span class=\"listen\">Listen</span>";
            return;
          }

          if ('speechSynthesis' in window) {
            utterance = new SpeechSynthesisUtterance(content.innerText);

            // Optional: Customize voice, speed, pitch, etc.
            // You might need to wait for voices to load asynchronously
            // utterance.voice = window.speechSynthesis.getVoices()[0];
            utterance.rate = 0.92;
            utterance.pitch = 1.1;

            utterance.onstart = () => {
              isSpeaking = true;
              /* button.textContent = 'Stop'; */
              button.innerHTML = "<span class=\"icon icon-24 icon-sound filter-dark-blue-hero\"></span><span class=\"listen\">Stop</span>";
            };

            utterance.onend = () => {
              isSpeaking = false;
              /* button.textContent = 'Listen'; */
              button.innerHTML = "<span class=\"icon icon-24 icon-sound filter-charcoal-hero\"></span><span class=\"listen\">Listen</span>";
            };

            window.speechSynthesis.speak(utterance);
          } else {
            // Fallback for browsers that don't support the API
            alert("Sorry, your browser does not support the Web Speech API's text-to-speech feature.");
          }
        }
        if (button !== null) {
          button.addEventListener('click', speakContent);
        }

      }

      function hideSortSelection() {
        let screenWidth = Drupal.layerone.getScreenWidth();
        let sortByButton = $('#sort-by-button');
        let displayName = $(sortByButton).find('.selection');
        if (screenWidth > 1399) {
            $(displayName).show();
            if (!$(displayName).hasClass('d-inline-block')) {
              $(displayName).addClass('d-inline-block');
            }
          }
          else {
            $(displayName).hide().removeClass('d-inline-block');
        }
      }

      // Initialize the button for the specific elements
      // setupSpeechButton('main-wrapper', 'listen-to-this-page');

      hideSortSelection();

      // Responsive tables
      $('.text-formatted table', context).addClass("table-striped").wrap('<div class="table-responsive"></div>')

      window.addEventListener('resize', function(){
        hideSortSelection();
      },true);

    }
  };

})(jQuery, Drupal);
